export function Emblem({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="apGrad" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor="hsl(38 92% 55%)" />
          <stop offset="1" stopColor="hsl(21 90% 48%)" />
        </linearGradient>
      </defs>
      <path
        d="M24 3l17 7v11c0 10.5-7 18.5-17 21C14 39 7 31 7 21V10l17-7z"
        fill="url(#apGrad)"
        opacity="0.15"
      />
      <path
        d="M24 3l17 7v11c0 10.5-7 18.5-17 21C14 39 7 31 7 21V10l17-7z"
        stroke="url(#apGrad)"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      {/* stylized shepherd / flame */}
      <path
        d="M24 13c3.5 3 5 6 5 9a5 5 0 11-10 0c0-1.4.6-2.8 1.6-4C21 20 22.5 21 23 22c.4-2 .3-5 1-9z"
        fill="url(#apGrad)"
      />
    </svg>
  );
}

export function Logo({ compact = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="app-logo">
      <Emblem />
      <div className="leading-none">
        <div className="font-display font-extrabold tracking-tight text-lg bg-gradient-to-r from-accent to-primary bg-clip-text text-transparent">
          APRISCO CHURCH
        </div>
        {!compact && (
          <div className="text-[10px] font-semibold uppercase tracking-[0.25em] text-muted-foreground mt-0.5">
            Zona Norte · Gestão PGD
          </div>
        )}
      </div>
    </div>
  );
}
